module.exports = __webpack_public_path__ + "img/yingxiao_chuda_icon.cb9463db.png";